import { createSlice } from "@reduxjs/toolkit";
import { CategoryType } from "./Types";

export type HistoryEntryType = {
  documentation_id: number;
  created_at: string;
  validation_status: string;
  validation_score: number;
  endorsement_level: string;
  submitted_by: number;
  partner_submission_date?: string | null;
  admin_submission_date?: string | null;
};

export type ValidationSummaryType = {
  scores: {
    mandatory: number;
    recommended: number;
    bestPractice: number;
    optional: number;
  };
  overall_score: number;
  total_validation_score: number;
  endorsement_level: string;
  integration_id: string;
  documentation_id: number;
};

type initialStateType = {
  currentDocumentationId: number | null;
  currentValidationStatus: string | null;
  documentationData: CategoryType[];
  historyData: HistoryEntryType[];
  summaryData: ValidationSummaryType | null;
  recentHistoryDocumentation: CategoryType[] | null;
  historyDetailDocumentation: CategoryType[];
  submittedBy: string | null;
  submittedByAdmin: string | null;
  status: {
    documentationLoading: boolean;
    documentationError: string | null;
    historyLoading: boolean;
    historyError: string | null;
    summaryLoading: boolean;
    summaryError: string | null;
    recentHistoryLoading: boolean;
    recentHistoryError: string | null;
    historyDetailLoading: boolean;
    historyDetailError: string | null;
    historyReportExportLoading: boolean;
    certificateDownloadLoading: boolean;
  };
};

var initialState: initialStateType = {
  currentDocumentationId: null,
  currentValidationStatus: null,
  documentationData: [],
  historyData: [],
  summaryData: null,
  recentHistoryDocumentation: null,
  historyDetailDocumentation: [],
  submittedBy: null,
  submittedByAdmin: null,
  status: {
    documentationLoading: false,
    documentationError: null,
    historyLoading: false,
    historyError: null,
    summaryLoading: false,
    summaryError: null,
    recentHistoryLoading: false,
    recentHistoryError: null,
    historyDetailLoading: false,
    historyDetailError: null,
    historyReportExportLoading: false,
    certificateDownloadLoading: false,
  },
};

const validationDocumentationSlice = createSlice({
  name: "validation-documentation",
  initialState: initialState,
  reducers: {
    setCurrentDocumentationId: (state, action) => {
      state.currentDocumentationId = action.payload;
    },
    setCurrentValidationStatus: (state, action) => {
      state.currentValidationStatus = action.payload;
    },
    setDocumentationData: (state, action) => {
      state.documentationData = action.payload;
    },
    setDocumentationLoading: (state, action) => {
      state.status.documentationLoading = action.payload;
    },
    setDocumentationError: (state, action) => {
      state.status.documentationError = action.payload;
    },
    setHistoryData: (state, action) => {
      state.historyData = action.payload;
    },
    setHistoryLoading: (state, action) => {
      state.status.historyLoading = action.payload;
    },
    setHistoryError: (state, action) => {
      state.status.historyError = action.payload;
    },
    setSummaryData: (state, action) => {
      state.summaryData = action.payload;
    },
    setSummaryLoading: (state, action) => {
      state.status.summaryLoading = action.payload;
    },
    setSummaryError: (state, action) => {
      state.status.summaryError = action.payload;
    },
    setRecentHistoryDocumentation: (state, action) => {
      state.recentHistoryDocumentation = action.payload;
    },
    setRecentHistoryLoading: (state, action) => {
      state.status.recentHistoryLoading = action.payload;
    },
    setRecentHistoryError: (state, action) => {
      state.status.recentHistoryError = action.payload;
    },
    setHistoryDetailDocumentation: (state, action) => {
      state.historyDetailDocumentation = action.payload;
    },
    setHistoryDetailLoading: (state, action) => {
      state.status.historyDetailLoading = action.payload;
    },
    setHistoryDetailError: (state, action) => {
      state.status.historyDetailError = action.payload;
    },
    setHistoryReportExportLoading: (state, action) => {
      state.status.historyReportExportLoading = action.payload;
    },
    setCertificateDownloadLoading: (state, action) => {
      state.status.certificateDownloadLoading = action.payload;
    },
    setSubmittedBy: (state, action) => {
      state.submittedBy = action.payload;
    },
    setSubmittedByAdmin: (state, action) => {
      state.submittedByAdmin = action.payload;
    },
    resetValidationState: (state) => {
      state.currentDocumentationId = null;
      state.currentValidationStatus = null;
      state.documentationData = [];
      state.historyData = [];
      state.summaryData = null;
      state.recentHistoryDocumentation = null;
      state.historyDetailDocumentation = [];
      state.submittedBy = null;
      state.submittedByAdmin = null;
      state.status = {
        documentationLoading: false,
        documentationError: null,
        historyLoading: false,
        historyError: null,
        summaryLoading: false,
        summaryError: null,
        recentHistoryLoading: false,
        recentHistoryError: null,
        historyDetailLoading: false,
        historyDetailError: null,
        historyReportExportLoading: false,
        certificateDownloadLoading: false,
      };
    },
  },
});

export const validationDocumentationSliceReducer =
  validationDocumentationSlice.reducer;
export const validationDocumentationSliceAction =
  validationDocumentationSlice.actions;
